import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Bell } from '@phosphor-icons/react';
import { useAppStore } from '@/store/appStore';
import { ActividadModal } from '@/components/feed/ActividadModal';

// Etiqueta a mostrar centrada en el TopBar. Es solo texto, no clickeable:
// da contexto de "donde estoy" sin saturar con tabs. Las 4 vistas de tareas
// (kanban/tabla/planificador/calendario) comparten el título "Tareas" — el
// tipo de vista activo se ve en la ViewToolbar de abajo.
function useCenterLabel(): string {
  const location = useLocation();
  const sitePlanProject = useAppStore((s) => s.sitePlanProject);

  const pathname = location.pathname;

  if (pathname === '/')              return 'Dashboard';
  if (pathname === '/feed')          return 'Actividad';
  if (pathname.startsWith('/kanban/')
    || pathname === '/table'
    || pathname === '/planner'
    || pathname === '/calendar')     return 'Tareas';
  if (pathname === '/site-plan')     return `Sitio · ${sitePlanProject}`;
  if (pathname === '/tramites')      return 'Trámites';
  if (pathname === '/configuracion') return 'Configuración';
  return 'ArquiFlow';
}

export function TopBar() {
  const label = useCenterLabel();
  const [actividadOpen, setActividadOpen] = useState(false);

  return (
    // El `pt` del recorte NO es un margen de diseño: es el espacio donde el
    // teléfono dibuja la hora, la señal y la isla. Daniel lo reportó el
    // 21-oct-2026 sobre un 17 Pro Max —«la barra de arriba se pierde entre los
    // íconos de la batería, de la señal y la hora»— y medido fue peor que eso:
    // la franja entera mide 48 px y el recorte de ese aparato son 62, así que
    // la barra no quedaba a medias debajo, quedaba COMPLETA debajo.
    //
    // El fondo oscuro va en el elemento de afuera y el contenido en el de
    // adentro, a propósito: así el gris de marca llega hasta el borde 0 —la
    // hora queda sobre un fondo propio, que es como se ve una app nativa— y lo
    // que se toca empieza recién debajo del recorte. Un solo div con padding
    // daría lo mismo acá, pero no en el editor, donde la barra es blanca y el
    // cinturón tiene que seguir siendo oscuro para que la hora se lea.
    <div data-franja="arriba" className="bg-brand-gray-500 pt-[var(--franja-arriba)] text-white">
    <div className="flex h-12 items-center gap-2 px-3">
      {/* Izq: logo */}
      <img
        src="/arquiflow_horizontal_w.svg"
        alt="ArquiFlow"
        className="h-6 shrink-0"
      />

      {/* Centro: label de la vista actual (solo lectura, ver decision 1.B) */}
      <div className="flex flex-1 items-center justify-center min-w-0">
        <span
          className="truncate px-2 py-1 text-sm font-semibold text-white"
          title={label}
        >
          {label}
        </span>
      </div>

      {/* Der: campana — abre el modal de Actividad del equipo (feed) desde
          cualquier pantalla. Reemplaza el item "Actividad" del menu. */}
      <button
        type="button"
        onClick={() => setActividadOpen(true)}
        title="Actividad"
        aria-label="Actividad"
        className="shrink-0 rounded-md p-1.5 hover:bg-brand-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-green-100"
      >
        <Bell size={18} weight="bold" />
      </button>

      <ActividadModal open={actividadOpen} onClose={() => setActividadOpen(false)} />
    </div>
    </div>
  );
}
